<template>
  <div id="glass-units-table">
    <div class="table-wrapper">
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            v-for="(header, i) in headers"
            :key="i"
            class="rTableHead unselectable"
            :class="{ 'clickable': header.value }"
            :style="{ 'width': header.width + '%'}"
            @click="changeSort(header.value)"
          >
            <span>{{header.text}}</span>
            <span v-if="header.value === sortBy && !header.unsortable">
              <v-icon small v-if="descending">north</v-icon>
              <v-icon small v-else>south</v-icon>
            </span>
          </div>
        </div>
        <div class="rTableRow" v-for="(glassUnit, i ) in glassUnits" :key="i">
          <div class="rTableCell">{{glassUnit.stand_number}}</div>
          <div class="rTableCell">{{glassUnit.stand_side}}</div>
          <div class="rTableCell">{{glassUnit.width}} x {{glassUnit.height}}</div>
          <div class="rTableCell">{{glassUnit.type}}</div>
          <div class="rTableCell">{{glassUnit.customer_order}}</div>
          <div class="rTableCell">{{glassUnit.customer_position}}</div>
          <div class="rTableCell">{{glassUnit.supplier_order}}</div>
          <div class="rTableCell">{{glassUnit.supplier_position}}</div>
        </div>
      </div>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="page" :length="pages"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "glass-units-table",
  props: ["glassUnits"],
  data() {
    return {
      sortBy: "stand_number",
      descending: false,
      pages: 1,
      page: 1,
      headers: [
        {
          text: "Stovo Nr.",
          value: "stand_number",
          width: 10,
        },
        {
          text: "Stovo pusė",
          value: "stand_side",
          width: 5
        },
        {
          text: "Matmenys",
          unsortable: true,
          width: 20,
        },
        {
          text: "Gaminys",
          value: "type",
          width: 25,
        },
        {
          text: "Užsakovo užsakymo nr.",
          value: "customer_order",
          width: 10,
        },
        {
          text: "Užsakovo inf.",
          value: "customer_position",
          width: 5,
        },
        {
          text: "Užsakymo Nr.",
          value: "supplier_order",
          width: 20,
        },
        {
          text: "Pos. Nr.",
          value: "supplier_position",
          width: 5,
        },
      ],
    };
  },
  watch: {
    page(val) {
      this.$emit("pageChanged", val);
    },
  },
  methods: {
    updatePages(pages, page) {
      this.pages = pages;
      this.page = page;
    },

    changeSort(header) {
      if (!header) return;
      if (this.sortBy === header) {
        this.descending = !this.descending;
      } else {
        this.sortBy = header;
        this.descending = false;
      }
      this.$emit("sortChanged", {
        sort_by: this.sortBy,
        descending: this.descending,
      });
    },
  },
};
</script>

<style>
</style>